var _desc, _defs, _ellipse, _ellipse2, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPiggyBankIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "63px",
    viewBox: "0 0 65 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-tertiary-mental-health-counselling") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.2351515%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.055990,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.500000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.083984,1.000000),rotate(90.000000),scale(1.000000,10.390143),translate(-0.489155,-0.509384)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.2351515%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.111111,1.000000),rotate(90.000000),scale(1.000000,12.710552),translate(-0.500000,-0.500000)",
    id: "radialGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.133333,1.000000),rotate(90.000000),scale(1.000000,10.263689),translate(-0.489155,-0.509384)",
    id: "radialGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.2,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-6",
    cx: 15.875969,
    cy: 15.875969,
    r: 15.875969
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-7",
    cx: 15.875969,
    cy: 15.875969,
    r: 13.369237
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.7%",
    y: "-3.7%",
    width: "107.5%",
    height: "107.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-9",
    cx: 15.875969,
    cy: 15.875969,
    r: 13.369237
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.7%",
    y: "-3.7%",
    width: "107.5%",
    height: "107.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "12.5268297%",
    y1: "8.66166063%",
    x2: "92.7056207%",
    y2: "94.462755%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0.0712626689%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.15,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "3.061617e-15%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.345412334,0.0218280845 L31.4181383,0.000231996606 C31.6022332,0.000104047451 31.7515753,0.149238705 31.7517032,0.333333577 C31.7517034,0.33348894 31.7517033,0.333644303 31.7517032,0.333799666 L31.7396272,17.5055382 C31.7394979,17.6894511 31.5904385,17.8385092 31.4065257,17.838637 L0.333799668,17.8602331 C0.149704796,17.8603611 0.000362691579,17.7112264 0.000234742423,17.5271315 C0.000234634443,17.5269762 0.000234635083,17.5268208 0.000234744342,17.5266655 L0.0123107554,0.354926921 C0.012440092,0.171014043 0.161499454,0.0219559072 0.345412334,0.0218280845 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.5123255%",
    y1: "65.4126161%",
    x2: "19.6413923%",
    y2: "29.2744305%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.5123255%",
    y1: "67.1816488%",
    x2: "19.6413923%",
    y2: "26.8955864%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.449408,37.6570229 L44.7243287,40.7952195 C44.8997299,41.2269667 45.3351641,41.4948157 45.7996159,41.4566619 L51.3652078,40.99946 C51.9184479,40.9540124 52.3442974,40.4917458 52.3442974,39.9366421 L52.3442974,32.4692018 C52.3443179,32.328291 52.4000989,32.1931099 52.4994694,32.0932033 C56.2243121,28.3482659 58.0867334,23.9349995 58.0867334,18.853404 C58.0867334,14.2168952 52.6223577,2.13162821e-14 31.4315916,2.13162821e-14 C22.8855214,2.13162821e-14 17.0373179,1.81968178 13.8869812,5.45904534 C9.57906417,4.85873795 7.16349125,5.24547444 6.64026246,6.61925481 C6.14051254,7.27532214 6.57154561,8.6751806 7.93336168,10.8188302 C8.05846992,11.0158049 8.09133545,11.2575921 8.02332282,11.4808081 L6.6794914,15.8912334 C6.60546704,16.1341798 6.42045568,16.3275282 6.18100578,16.4121819 L1.51774942,18.0608037 C0.276316473,18.499693 -0.37948348,19.8570437 0.0482240596,21.1023733 L2.22024137,27.4265019 C2.48094502,28.1855766 3.10391374,28.7640336 3.88019863,28.9678536 L10.1410631,30.6116953 C10.3649241,30.6704718 10.5635859,30.8004836 10.7070547,30.9821017 L12.1254955,32.7777142 C12.2507782,32.9363103 12.328412,33.1272435 12.3493508,33.328266 L13.0220696,39.7866709 C13.0729266,40.2749212 13.4505221,40.6653791 13.9367957,40.7325562 L18.9703608,41.4279267 C19.3804642,41.4845811 19.7862976,41.2987583 20.0113554,40.9512767 L22.1449862,37.6570229 L22.1449862,37.6570229 C25.7780491,38.4276098 28.8735842,38.8129032 31.4315916,38.8129032 C33.9895991,38.8129032 37.9955378,38.4276098 43.449408,37.6570229 Z",
    id: "path-16"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.6%",
    y: "-14.5%",
    width: "107.0%",
    height: "119.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-17"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -8,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.8590152%",
    y1: "69.2627824%",
    x2: "50%",
    y2: "51.9309257%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.1264083%",
    y1: "58.6697366%",
    x2: "47.7725787%",
    y2: "44.4412013%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5ACA9",
    offset: "0.00527871622%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD0CE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.1267438%",
    y1: "59.890686%",
    x2: "47.7725787%",
    y2: "43.6589112%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5ACA9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD0CE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.194402,5.62284669 C29.0190808,5.2469291 30.2634555,4.96099031 31.7516766,4.96099031 C32.9584302,4.96099031 33.6898131,5.10661241 35.0409326,5.52724614 L35.2555608,5.5940727 C35.4814866,5.66423457 35.6435631,5.71327475 35.8095165,5.76092365 C36.336106,5.91211909 36.8855592,5.60780213 37.0367546,5.08121269 C37.1879501,4.55462325 36.8836331,4.00517005 36.3570437,3.8539746 C36.2074989,3.81103699 36.0574648,3.76564053 35.8439752,3.69934075 L35.6306764,3.63292754 C34.1052771,3.15803666 33.1959965,2.97699419 31.7516766,2.97699419 C29.9709669,2.97699419 28.4475602,3.32705038 27.3714895,3.81756124 C26.8729737,4.04480226 26.653062,4.63314442 26.880303,5.13166024 C27.107544,5.63017605 27.6958862,5.85008772 28.194402,5.62284669 Z",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-19.4%",
    y: "-106.3%",
    width: "138.9%",
    height: "241.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-22"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.341176471   0 0 0 0 0.341176471   0 0 0 0 0.337254902  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "50%",
    x2: "50%",
    y2: "3.061617e-15%",
    id: "linearGradient-23"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-24",
    cx: 14.0899225,
    cy: 17.0666667,
    rx: 2.18294574,
    ry: 3.1751938
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-45.8%",
    y: "-47.2%",
    width: "191.6%",
    height: "163.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-25"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.341176471   0 0 0 0 0.341176471   0 0 0 0 0.337254902  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "linearGradient-26"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "linearGradient-27"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "HH---Employer-Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Employer-Dashboard-LG-03.13.0",
    transform: "translate(-938.000000, -958.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Health-Tracker",
    transform: "translate(62.000000, 759.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Panel",
    transform: "translate(33.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(726.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-tertiary-financial-wellbeing",
    transform: "translate(118.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow-large",
    transform: "translate(0.000000, 59.534884)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-1)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 31.751938,
    cy: 1.77777778,
    rx: 31.751938,
    ry: 1.77777778
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-2)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 31.751938,
    cy: 1.33333333,
    rx: 15.875969,
    ry: 1.33333333
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadow-small",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(4.961240, 60.527132)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-3)",
    cx: 12,
    cy: 1.33333333,
    rx: 12,
    ry: 1.33333333
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-4)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 12,
    cy: 0.888888889,
    rx: 6.66666667,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadow-small",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(35.720930, 60.527132)"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-3)",
    cx: 12,
    cy: 1.33333333,
    rx: 12,
    ry: 1.33333333
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-4)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 12,
    cy: 0.888888889,
    rx: 6.66666667,
    ry: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    strokeWidth: 1,
    transform: "translate(48.050156, 16.436312) rotate(8.000000) translate(-48.050156, -16.436312) translate(31.678063, 0.064219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D9D9D9",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-5)",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    opacity: 0.65,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    opacity: 0.5,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "url(#linearGradient-11)",
    strokeWidth: 0.533333333,
    opacity: 0.5,
    cx: 15.875969,
    cy: 15.875969,
    r: 15.6093023
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.9885047,12.3096281 C13.9885047,13.1149309 14.1241504,13.8281991 14.3502265,14.8175711 L18.1935204,14.8175711 L18.1935204,15.3927873 C18.1935204,16.1290642 17.6283302,16.4511853 17.0405323,16.4511853 L14.6215179,16.4511853 C14.7345559,17.0724188 14.7571635,17.5556005 14.7571635,17.8317043 C14.7571635,18.8670936 14.4180494,20.5237164 13.8754667,21.2830019 L13.8754667,21.3980452 L20.4994968,21.3980452 L20.4994968,22.065296 C20.4994968,22.8015729 19.9795217,23.2847545 19.0526097,23.2847545 L10.8008315,23.2847545 L10.8008315,22.7325469 C10.8008315,21.9042355 11.3886294,21.4440625 11.9312121,20.7538029 C12.4511872,20.0865521 12.7450861,19.235232 12.7450861,18.1078081 C12.7450861,17.6706437 12.6320481,16.9343669 12.51901,16.4511853 L10.0547804,16.4511853 L10.0547804,15.875969 C10.0547804,15.2087181 10.4391098,14.8175711 11.1399457,14.8175711 L12.2703263,14.8175711 C12.0216425,13.6211212 11.9086045,13.0919223 11.9086045,12.2866195 C11.9086045,9.5715987 13.7850362,7.40878553 16.8596714,7.40878553 C18.5326346,7.40878553 19.9116989,8.46718346 19.9116989,9.8016852 L19.9116989,10.9061004 L19.7986609,10.9061004 C19.3691162,9.98575441 18.0352672,9.38752949 16.8596714,9.38752949 C14.847594,9.38752949 13.9885047,10.4689361 13.9885047,12.3096281 Z",
    id: "\\xA3",
    fill: "#F8F8F8",
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    transform: "translate(20.311165, 17.037901) rotate(20.000000) translate(-20.311165, -17.037901) translate(3.939072, 8.107669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeWidth: 0.927222276
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#62EBB9",
    d: "M0.475830289,0.485348692 L0.463937514,17.3965314 L31.2761077,17.3751164 L31.2880005,0.463933695 L0.475830289,0.485348692 Z",
    strokeLinejoin: "square",
    fill: "url(#linearGradient-12)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#F8F8F8",
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.992248062,0.992248062 L0.992248062,4.96124031 C3.18426195,4.96124031 4.96124031,3.18426195 4.96124031,0.992248062 C3.77658807,0.992248062 2.45359066,0.992248062 0.992248062,0.992248062 Z",
    id: "Oval",
    fill: "#62EBB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.992248062,12.8992248 L0.992248062,16.8682171 C3.18426195,16.8682171 4.96124031,15.0912387 4.96124031,12.8992248 C3.77658807,12.8992248 2.45359066,12.8992248 0.992248062,12.8992248 Z",
    id: "Oval",
    fill: "#62EBB9",
    transform: "translate(2.976744, 14.883721) scale(1, -1) translate(-2.976744, -14.883721) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7906977,0.992248062 L26.7906977,4.96124031 C28.9827116,4.96124031 30.7596899,3.18426195 30.7596899,0.992248062 C29.5750377,0.992248062 28.2520403,0.992248062 26.7906977,0.992248062 Z",
    id: "Oval",
    fill: "#62EBB9",
    transform: "translate(28.775194, 2.976744) scale(-1, 1) translate(-28.775194, -2.976744) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7906977,12.8992248 L26.7906977,16.8682171 C28.9827116,16.8682171 30.7596899,15.0912387 30.7596899,12.8992248 C29.5750377,12.8992248 28.2520403,12.8992248 26.7906977,12.8992248 Z",
    id: "Oval",
    fill: "#62EBB9",
    transform: "translate(28.775194, 14.883721) scale(-1, -1) translate(-28.775194, -14.883721) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#62EBB9",
    cx: 15.875969,
    cy: 8.93023256,
    r: 5.45736434
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#62EBB9",
    cx: 26.7906977,
    cy: 8.93023256,
    r: 1.98449612
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#62EBB9",
    cx: 4.96124031,
    cy: 8.93023256,
    r: 1.98449612
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    strokeWidth: 1,
    transform: "translate(0.000000, 19.844961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5901832,21.5835069 C58.2319592,22.0599389 61.1199513,23.0128029 61.4408393,20.6306429 C61.7617273,18.2484829 59.9968432,18.0896722 59.5155112,18.5661042 C59.0341792,19.0425362 59.9968432,21.4246962 61.7617273,20.6306429 C62.9383167,20.101274 63.4196487,19.4130944 63.2057234,18.5661042",
    id: "Path-21",
    stroke: "url(#linearGradient-14)",
    strokeWidth: 0.533198959,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-19"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-17)",
    xlinkHref: "#path-16"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-15)",
    fillRule: "evenodd",
    xlinkHref: "#path-16"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-18)",
    cx: 32.248062,
    cy: 25.7984496,
    rx: 14.3875969,
    ry: 8.93023256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4055233,40.0345203 L44.4055233,40.0345203 L44.4055233,40.0345203 L44.7220097,40.801149 C44.8989925,41.2298563 45.3327776,41.4950118 45.7950231,41.4570392 L51.3652078,40.99946 C51.9184479,40.9540124 52.3442974,40.4917458 52.3442974,39.9366421 L52.3442974,38.4777132 L52.3442974,38.4777132 L50.6644398,38.2966085 C48.4328035,38.0560167 46.1936257,38.6777687 44.4055233,40.0345203 Z",
    id: "Path-19",
    fill: "url(#linearGradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8778464,39.8081698 L12.8778464,39.8081698 L12.8778464,39.8081698 L13.6290919,40.9614243 C13.8519719,41.3035727 14.2506622,41.4884068 14.6558048,41.4374118 L19.6975568,40.8028101 C20.1978392,40.7398399 20.585644,40.3350775 20.6271583,39.8325595 L20.7581153,38.2473656 L20.7581153,38.2473656 L18.9890799,38.0621433 C16.8029712,37.8332524 14.6130694,38.4589243 12.8778464,39.8081698 Z",
    id: "Path-19",
    fill: "url(#linearGradient-20)",
    transform: "translate(16.817981, 39.613103) scale(-1, 1) translate(-16.817981, -39.613103) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-20"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-22)",
    xlinkHref: "#path-21"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-23)",
    opacity: 0.200000003,
    transform: "translate(3.176148, 23.514312) rotate(-15.000000) translate(-3.176148, -23.514312) ",
    cx: 3.17614795,
    cy: 23.5143123,
    rx: 1,
    ry: 3.1751938
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-25)",
    xlinkHref: "#path-24"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-24"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.449408,37.6570229 C47.4257716,35.4744498 49.6124031,34.1847136 50.0093023,33.7878144 C50.6046512,33.1924655 47.1109571,37.9617006 43.8238857,38.5570494 C43.8238857,38.5570494 43.6990598,38.2570406 43.449408,37.6570229 Z",
    id: "Path-2",
    fill: "url(#linearGradient-26)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0847231,37.6570229 C19.3526939,35.4744498 21.6851289,34.1847136 22.0820281,33.7878144 C22.6773769,33.1924655 18.9370811,37.9340237 15.6500097,38.5293726 C15.6500097,38.5293726 15.4615808,38.2385893 15.0847231,37.6570229 Z",
    id: "Path-2",
    fill: "url(#linearGradient-27)",
    opacity: 0.25,
    transform: "translate(18.614855, 36.132798) scale(-1, 1) translate(-18.614855, -36.132798) "
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggyBankIcon);
export default __webpack_public_path__ + "static/media/piggy-bank-icon.09dbfda60dc0176127ab15a9536d7e91.svg";
export { ForwardRef as ReactComponent };